import React from 'react'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import { useSelector } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import themes from 'src/config/theme/theme.config'
import AppLocale from 'src/config/translation'
import 'moment/locale/vi'
import locale1 from 'antd/es/date-picker/locale/vi_VN'

export default function AppProvider({ children }) {
  const { locale } = useSelector(state => state.LanguageSwitcher.language)
  const { themeName } = useSelector(state => state.ThemeSwitcher.changeThemes)
  const currentAppLocale = AppLocale[locale]
  return (
    // <ConfigProvider locale={currentAppLocale.antd}>
    <ConfigProvider locale={locale1}>
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <ThemeProvider theme={themes[themeName]}>{children}</ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
  )
}
